import { render, staticRenderFns } from "./MTxtbtn.vue?vue&type=template&id=59708b3b&"
import script from "./MTxtbtn.vue?vue&type=script&lang=ts&"
export * from "./MTxtbtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports